<div
  *ngIf="selectedItem?.type === 'partial:card:video-player'"
  floScrollToElementOnNavigation
  #videoPlayer
  class="border-bottom pb-35"
>
  <flo-video-player-card [video]="selectedItem?.data"></flo-video-player-card>
</div>
<ng-container *ngIf="selectedNode$ | async as selectedNode">
  <flo-video-player
    floScrollToElementOnNavigation
    #videoPlayer
    [video]="selectedNode"
    [isAutoPlayed]="true"
    (played)="emitVideoEndedEvent()"
  ></flo-video-player>
  <h2 class="mt-2 pt-1 mb-2 headline font-family-bold">{{
    selectedNode?.title
  }}</h2>
  <p class="mb-2 date-text subhead color-500">{{
    selectedNode?.publish_start_date | date
  }}</p>
  <p
    *ngIf="selectedNode?.description; else plainDescription"
    [innerHtml]="selectedNode?.description | floSanitizeHtml"
    floDynamicContent
    class="mb-2 color-700 headline"
  ></p>
  <ng-template #plainDescription>
    <p class="mb-2 color-700 headline">{{ selectedNode?.description_plain }}</p>
  </ng-template>
  <div *ngIf="selectedNode.node?.tags" class="pt-2 pb-3">
    <flo-tags
      collectionTabUriPart="/video"
      [tags]="selectedNode.node.tags"
    ></flo-tags>
  </div>
  <div
    *ngIf="selectedNode.node?.tags"
    class="mt-1 pb-3 border-top border-grey-300"
  ></div>
  <div *ngIf="selectedNode.node?.tags" class="pt-3"></div>
</ng-container>
<ng-content></ng-content>
<ol
  *ngIf="listItemProps$ | async as listItemsProps"
  data-test="video-list"
  class="row ps-0"
>
  <flo-video-list-item
    *ngFor="let listItemProps of listItemsProps; trackBy: trackById"
    [props]="listItemProps"
    class="col-6 col-md-4 pb-4"
    (click)="emitThumbnailClick$.next(true)"
  ></flo-video-list-item>
</ol>
